import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import "./Skills.scss"
import ReactToolTip from "react-tooltip"
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';

const Skills = () => {
  const [skills, setSkills] = useState([])

  useEffect(() => {
    const query = "*[_type == 'skills']";

    client.fetch(query).then((data) => {
      setSkills(data)
    });
  }, []);

  return (
    <>
      <h2 className="head-text">Skills <span>&</span> Competencies</h2>

      <div className="app__skills-container">
        <motion.div
          className="app__skills-list"
        >
          {skills.map((skill) => (
            <div className="skills">
              <motion.div whileInView={{opacity: [0, 1]}} transition={{duration: 0.5}} className="app__skills-item app__flex" key={skill.name}>
                <div className="app__flex" style={{backgroundColor: skill.bgColor}}>
                  <img src={urlFor(skill.icon)} alt={skill.name}/>
                </div>
                <p className="p-text">{skill.name}</p>

              </motion.div>
              <Box sx={{width: "30%", textAlign: "center"}} className="progressBar">
                <LinearProgress variant="determinate" value={skill.percentage} />
                <p>{skill.description}</p>

              </Box>
            </div>

          ))}

        </motion.div>
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(Skills, "app__skills"), "skills", "app__whitebg")